import { Link } from "react-router-dom";
export default function ThankYou() {
  return (
    <div data-testid="page-thank-you" className="bg-[#F9F8F6] min-h-[80vh] flex items-center">
      <div className="container-editorial max-w-3xl">
        <div className="text-[10px] uppercase tracking-[0.32em] text-[#A85C42] mb-6">Enquiry received</div>
        <h1 className="font-serif text-5xl md:text-7xl tracking-tight leading-[1]">Thank you. We'll be in touch shortly.</h1>
        <p className="mt-8 text-[#4A4642] leading-relaxed max-w-2xl">Our team reviews every enquiry personally. You'll hear from us within 1–2 business days to schedule your consultation. In the meantime, feel free to explore recent work.</p>
        <div className="mt-10 flex gap-4">
          <Link to="/portfolio" className="px-8 py-4 bg-[#2B2927] text-[#F9F8F6] text-xs uppercase tracking-[0.24em] rounded-sm hover:bg-[#A85C42] transition-colors">View projects</Link>
          <Link to="/" className="px-8 py-4 border border-[#2B2927] text-[#2B2927] text-xs uppercase tracking-[0.24em] rounded-sm hover:bg-[#2B2927] hover:text-[#F9F8F6] transition-colors">Return home</Link>
        </div>
      </div>
    </div>
  );
}
